export const DEFAULT_REGISTERED_BUSINESS_ADDRESS_COUNTRY = 'United States';
export const DEAFULT_US_PHONE_CODE = '+1';
export const MAX_ZIP_CODE_FOR_NON_US = 8;
export const MAX_ZIP_CODE_FOR_US = 5;

export const MAX_PHONE_NUMBER_FIELD_LENGTH = 15;
